import { ticketProperty } from "../../property/resource/ticket-property";
import { ResourceColumn } from "../planner-column";

export const ticketColumn = new ResourceColumn(
  'Tickets',
  'stl_item_usable_0002.g1t.png',
  'tickets',
  ticketProperty,
)
